<template>
  <div class="h-index">
    <h-banner></h-banner>
    <h-minor-banner></h-minor-banner>
    <h-main></h-main>
    <h-float-icon></h-float-icon>
    <h-foot></h-foot>
  </div>
</template>

<script>


import HHeader from "@/page/components/h-header";
import HBanner from "@/page/components/h-banner";
import HMinorBanner from "@/page/components/h-minor-banner";
import HMain from "@/page/components/h-main";
import HFloatIcon from "@/page/components/h-float-icon";
import HFoot from '@/page/components/h-foot'


export default {
  name: "index",
  components: { HFoot, HFloatIcon, HMain, HMinorBanner, HBanner, HHeader},
  data() {
    return {
      dataset: {},
      data: {},
      flag: '',
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
    },
  },
}
</script>

<style scoped>
.h-index{
  /*padding-bottom: 60px;*/
}
</style>
